import { MotorInsurancepage } from "component/MotorPage";
import { MotorInsurancepageMobile } from "component/MotorPage/MotorInsurancepage/MotorInsurancepageMobile";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import CommonHelmet from "../../component/common/CommonHelmet";

const MotorInsurancePage = () => {
    const { i18n, t } = useTranslation();
    const location = useLocation();
    const selectedLanguage = localStorage.getItem("lang");

    useEffect(() => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "view_item",
            ecommerce: {
                funnel_step: "step_0",
                step_name: "motor_policy_new_view_item",
                items: [
                    {
                        item_name: "Motor Insurance New",
                        item_category: "Motor Insurance",
                        item_class: "Individual",
                    }
                ]
            }
        });
        window.lmSMTObj.page("MotorInsurancePage", {
            path: document.location.pathname,
            language: selectedLanguage == 'ar' ? "Arabic" : "English",
            referrer: document.referrer,
            title: document.title,
            url: document.URL,
            search: location.search,
        });
    }, []);

    return (
        <React.Fragment>
            <CommonHelmet title={t("metaData.motor.title")} desc={t("metaData.motor.desc")} h1Content={t("metaData.motor.h1")}/>
            {window.innerWidth < 950 ? <MotorInsurancepageMobile /> : <MotorInsurancepage />}
        </React.Fragment>
    );
};

export default MotorInsurancePage;
